import React, { useEffect, useState } from "react";
import { CanvasProvider } from "./PreviewCanvasContext";
import Canvas from "./Canvas";
import { useDispatch, useSelector } from "react-redux";
import { setPreviewMode } from "../../store/common/uiSlice";
import PreviewControl from "./PreviewControl";
import { FianalGenerateVideo } from "../../thunks/editor/canvasThunks";

function Previewer() {
  const [onCloseSelect, setOnCloseSelect] = useState(false);
  const [slideTransition, setSlideTransition] = useState();
  const { slides, currentPreviewSlide } = useSelector((state) => state.slides);

  useEffect(() => {
    if (currentPreviewSlide && slides[currentPreviewSlide - 1]) {
      handleSlideTransition(slides[currentPreviewSlide - 1].transitionData);
    }
  }, [currentPreviewSlide, slides]);

  const handleSlideTransition = (value) => setSlideTransition(value);

  return (
    <div className={`flex flex-col absolute h-full w-full bg-gray-500/90 z-50`}>
      <div className="flex justify-end space-x-4 mt-4 mr-8 z-10">
        <button
          className="p-4 py-2 bg-gray-700 text-white absolute top-10 hover:bg-blue-700 rounded-lg"
          onClick={() => setOnCloseSelect(true)}
        >
          Close
        </button>
        {/* <button
          onClick={() => dispatch(FianalGenerateVideo())}
          className="p-4 py-2 bg-gray-700 text-white hover:bg-blue-700 rounded-lg"
        >
          Generate Video
        </button> */}
      </div>
      <CanvasProvider>
        <Canvas previewMode={true} slideTransition={slideTransition} />
        <PreviewControl onCloseSelect={onCloseSelect} />
      </CanvasProvider>
    </div>
  );
}

export default Previewer;
